(ns practitest.frontend.project-fields-settings.views
  (:require
    [re-frame.core :as re-frame]
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.common.i18n :refer [get-translation format-translation]]
    [practitest.frontend.components2.buttons :as buttons]
    [practitest.frontend.components2.confirmation-modal :refer [confirmation-modal]]
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.subs :as subs]
    [practitest.frontend.project-fields-settings.subs :as pf-subs]
    [practitest.frontend.project-fields-settings.events :as pf-events]
    [practitest.frontend.forms3.custom-field-form-common :as cf-form-common]
    [practitest.frontend.forms3.project-field-form :as project-field-form]
    [practitest.frontend.common.re-frame :refer [partial-subscribe partial-dispatch-sync]]
    [practitest.frontend.forms3.entity-form.forms :as forms3]
    [reagent.core :as r]))

(defn- save-button-on-click [{:keys [edit? is-global-field?]}]
  (let [form-errors (project-field-form/force-form-validation! {:edit? edit? :is-global-field? is-global-field?})]
    (when-not (seq form-errors)
      (re-frame/dispatch [::pf-events/check-field-relationship edit?]))))

(defn- convert-field-type-button []
  (let [field-id @(re-frame/subscribe [::pf-subs/custom-field-id])
        form-data @(re-frame/subscribe [::pf-subs/custom-fields-form-data])
        field-format (get-in form-data [:cf-format :value])
        has-source-list? (boolean (get-in form-data [:cf-source-list :value]))
        convert-actions (cf-form-common/get-convert-actions
                          {:field-format field-format
                           :has-source-list? has-source-list?
                           :mixpanel-category "Project Field Convert"
                           :on-select-target (fn [target]
                                                (re-frame/dispatch [::pf-events/show-convert-confirmation field-id target]))})]
    [cf-form-common/convert-field-type-button {:convert-actions convert-actions}]))

(defn- sh-form-header [{:keys [edit?]}]
  (let [is-global-field? (:is_global_field @(re-frame/subscribe [:project-fields-settings/seeded-custom-field]))]
    (cf-form-common/form-header
     {:title (cond
               is-global-field? (get-translation "custom-fields.edit-global-form.title" "Edit Global Field")
               edit? (get-translation "custom-fields.edit-form.title" "Update Custom Field")
               :else (get-translation "custom-fields.create-form.title" "Create Custom Field"))
      :convert-button (when edit?
                        (if is-global-field?
                          [cf-form-common/convert-field-type-button
                           {:convert-actions [{:label   (get-translation "global-fields.convert.button" "Convert")
                                               :disabled? true
                                               :tooltip (get-translation "custom-fields.convert.global-field.tooltip"
                                                                         "Field type is managed in account settings")}]}]
                          [convert-field-type-button]))})))

(defn- sh-form-footer [{:keys [edit?]}]
  (let [project-id @(re-frame/subscribe [::subs/current-project-id])
        form-data @(re-frame/subscribe [::pf-subs/custom-fields-form-data])
        loading? @(re-frame/subscribe [:project-fields-settings/form-loading?])
        is-global-field? (:is_global_field @(re-frame/subscribe [:project-fields-settings/seeded-custom-field]))]
    [:div.view-footer
     [buttons/button {:text (get-translation "generic.button.save" "Save")
                      :primary? true
                      :disabled? (or (cf-form-common/save-button-disabled? form-data) loading?)
                      :on-click (fn []
                                  (when-not edit? (mixpanel/track
                                                   "Create_Project_Field"
                                                   {"Type" (get-in form-data [:cf-format :value])}))
                                  (save-button-on-click {:edit? edit? :is-global-field? is-global-field?}))}]
     [buttons/button {:text (get-translation "global-fields.form-footer.back-to-list" "Back to List")
                      :tertiary? true
                      :href (str "/projects/" project-id "/custom_fields")}]]))

(defn- convert-confirmation-modal []
  (let [{:keys [convert-confirm? convert-field-id convert-target]}
        @(re-frame/subscribe [::pf-subs/custom-fields-modal-data])
        has-source-list-children? (:has_source_list_children @(re-frame/subscribe [:project-fields-settings/seeded-custom-field]))]
    (cf-form-common/convert-confirmation-modal
     {:convert-confirm? convert-confirm?
      :convert-target convert-target
      :mixpanel-category "Project Field Convert"
      :warning           (when (and (= convert-target "text") has-source-list-children?)
                           (get-translation "custom-fields.convert.has-source-list-children.warning"
                                            "Note: Some fields currently take their values from this field. Converting to text will disconnect them from this source list."))
      :on-yes (fn [] (re-frame/dispatch [::pf-events/convert-field convert-field-id convert-target]))
      :on-no (fn [] (re-frame/dispatch [::pf-events/project-fields-hide-modal :modal-data]))})))

(defn- check-possible-value-deletion-modal []
  (let [modal-data @(re-frame/subscribe [::pf-subs/custom-fields-modal-data])]
    [cf-form-common/delete-possible-value-modal
     {:modal-data modal-data
      :on-confirm (fn [value] (re-frame/dispatch [::pf-events/delete-possible-value value (:parent-item modal-data)]))
      :on-cancel  #(re-frame/dispatch [::pf-events/project-fields-hide-modal :modal-data])}]))

(defn- convert-blocked-alert []
  (let [{:keys [convert-blocked? title message usages]}
        @(re-frame/subscribe [::pf-subs/custom-fields-modal-data])]
    (cf-form-common/convert-blocked-alert
     {:show?     convert-blocked?
      :title     title
      :message   message
      :usages    usages
      :on-cancel #(re-frame/dispatch [::pf-events/project-fields-hide-modal :modal-data])})))

(defn- save-blocked-alert []
  (let [{:keys [save-blocked? title message usages]}
        @(re-frame/subscribe [::pf-subs/custom-fields-modal-data])]
    (cf-form-common/convert-blocked-alert
     {:show?     save-blocked?
      :title     title
      :message   message
      :usages    usages
      :on-cancel #(re-frame/dispatch [::pf-events/project-fields-hide-modal :modal-data])})))

(defn- check-field-relationship-modal [{:keys [edit?]}]
  (let [{:keys [title message]} @(re-frame/subscribe [::pf-subs/custom-fields-linkage-modal-data])]
    [confirmation-modal
     {:show?        (boolean @(re-frame/subscribe [::pf-subs/custom-fields-show-linkage-modal]))
      :show-footer? true
      :title        title
      :confirmation-button-text (get-translation "generic.button.confirm" "Confirm")
      :on-confirm   (fn [] (re-frame/dispatch [::pf-events/save-custom-field {:edit? edit?}])
                      (re-frame/dispatch [::pf-events/project-fields-hide-modal :linkage-modal-data]))
      :on-cancel    (fn []
                      (re-frame/dispatch [::pf-events/project-fields-hide-modal :linkage-modal-data])
                      (re-frame/dispatch [::pf-events/clear-form-loading]))}
     [:div message]]))

(defn- rename-value-modal []
  (let [{:keys [show? old-value new-value error]}
        @(re-frame/subscribe [::pf-subs/rename-modal-data])
        saving? @(re-frame/subscribe [::pf-subs/rename-saving?])]
    (cf-form-common/rename-value-modal
     {:show?     show?
      :old-value old-value
      :new-value new-value
      :saving?   saving?
      :error     error
      :on-cancel #(re-frame/dispatch [::pf-events/close-rename-modal])
      :on-change #(re-frame/dispatch [::pf-events/set-rename-new-value (dom/event-value %)])
      :on-submit #(re-frame/dispatch [::pf-events/submit-rename-value])})))

(defn- source-list-confirm-modal []
  (let [{:keys [show source-obj]} @(re-frame/subscribe [::pf-subs/source-list-confirm])]
    [confirmation-modal
     {:show?                    (boolean show)
      :show-footer?             true
      :title                    (get-translation "custom-fields.source-list.confirm-title" "Replace existing values?")
      :confirmation-button-text (get-translation "generic.button.confirm" "Confirm")
      :on-confirm               (fn [] (re-frame/dispatch [::pf-events/apply-source-list source-obj]))
      :on-cancel                (fn [] (re-frame/dispatch [::pf-events/cancel-source-list-confirm]))}
     [:p (format-translation (get-translation "custom-fields.source-list.confirm-message"
                                              "Taking values from \"%{field_name}\" will delete the values you've already defined for this field and replace them with the source list's values.")
                             {:field_name (:name source-obj)})]]))

(defn project-field-form-page [{:keys [edit?]}]
  [:div.global-fields-page.global-field-create-container
   [check-field-relationship-modal {:edit? edit?}]
   [check-possible-value-deletion-modal]
   [convert-confirmation-modal]
   [convert-blocked-alert]
   [save-blocked-alert]
   [rename-value-modal]
   [source-list-confirm-modal]
   [sh-form-header {:edit? edit?}]
   [:div.global-field-forms-container [project-field-form/project-field-form {:edit? edit?}]]
   [sh-form-footer {:edit? edit?}]])

;; ---- System Field Edit Page ----

(defn- sf-form-props []
  {:get-field-state (partial-subscribe [::forms3/field-state pf-events/sf-form-id])
   :set-field-state (partial-dispatch-sync [::forms3/set-field-state pf-events/sf-form-id])})

(defn- sf-save-blocked-alert []
  (let [{:keys [save-blocked? title message usages]}
        @(re-frame/subscribe [::pf-subs/sf-modal-data])]
    (cf-form-common/convert-blocked-alert
     {:show?     save-blocked?
      :title     title
      :message   message
      :usages    usages
      :on-cancel #(re-frame/dispatch [::pf-events/hide-sf-modal :modal-data])})))

(defn- sf-check-possible-value-deletion-modal []
  (let [modal-data @(re-frame/subscribe [::pf-subs/sf-modal-data])]
    [cf-form-common/delete-possible-value-modal
     {:modal-data modal-data
      :on-confirm (fn [_]
                    (re-frame/dispatch [::pf-events/sf-delete-possible-value]))
      :on-cancel  #(re-frame/dispatch [::pf-events/hide-sf-modal :modal-data])}]))

(defn- sf-rename-value-modal []
  (let [{:keys [show? old-value new-value error parent-item]}
        @(re-frame/subscribe [::pf-subs/sf-rename-modal-data])]
    (cf-form-common/rename-value-modal
     {:show?     show?
      :old-value old-value
      :new-value new-value
      :saving?   false
      :error     error
      :on-cancel #(re-frame/dispatch [::pf-events/sf-close-rename-modal])
      :on-change #(re-frame/dispatch [::pf-events/sf-set-rename-new-value (dom/event-value %)])
      :on-submit #(re-frame/dispatch [::pf-events/sf-submit-rename-value])})))

(defn- sf-form-footer []
  (let [project-id @(re-frame/subscribe [::subs/current-project-id])
        form-data  @(re-frame/subscribe [::pf-subs/sf-form-data])
        loading?   @(re-frame/subscribe [:project-fields-settings/sf-form-loading?])]
    [:div.view-footer
     [buttons/button {:text      (get-translation "generic.button.save" "Save")
                      :primary?  true
                      :disabled? (or (cf-form-common/save-button-disabled? form-data) loading?)
                      :on-click  #(re-frame/dispatch [::pf-events/save-system-field])}]
     [buttons/button {:text      (get-translation "global-fields.form-footer.back-to-list" "Back to List")
                      :tertiary? true
                      :href      (str "/projects/" project-id "/custom_fields")}]]))

(defn- sf-display-name-input [{:keys [get-field-state set-field-state]} system-field]
  (let [value (or (:value @(get-field-state :sf-display-name)) "")]
    [:div.g2-field-container
     [:label.m-label (get-translation "global-fields.form-fields.name" "Display Name")]
     [:div.sf-display-name-row
      [:input.m-input
       {:type      "text"
        :value     value
        :max-length 30
        :on-change (fn [e]
                     (set-field-state :sf-display-name
                                      {:value  (.. e -target -value)
                                       :dirty? true
                                       :errors []}))}]
      [:span.sf-uniq-name (str "(" (get-translation "global-fields.form-fields.unique-name" "unique name:") " " (:uniq_name system-field) ")")]]]))

(defn- system-field-edit-inner [system-field]
  (r/with-let [_ (re-frame/dispatch [::pf-events/init-system-field-form-values system-field])]
    (let [form-props          (sf-form-props)
          field-format        (:field_format system-field)
          allowed-entities    (:allowed-entity-keys system-field)
          users               @(re-frame/subscribe [::subs/users])
          possible-values     (:possible_values system-field)
          has-pv-editing?     (and (#{"list" "multilist"} field-format) (some? possible-values))
          has-ll-editing?     (= "linkedlist" field-format)
          parent-list-values  (when has-ll-editing? (:parent_list_values system-field))
          action-in-progress? @(re-frame/subscribe [::pf-subs/sf-action-in-progress?])
          project-id          @(re-frame/subscribe [::subs/current-project-id])]
      [:div.global-fields-page.global-field-create-container
       [sf-save-blocked-alert]
       [sf-check-possible-value-deletion-modal]
       [sf-rename-value-modal]
       [cf-form-common/form-header
        {:title          (get-translation "system-fields.edit-form.title" "Update System Field")
         :convert-button nil}]
       [:div.global-field-forms-container
        [:div.global-field-form
         [sf-display-name-input form-props system-field]
         (when has-pv-editing?
           [cf-form-common/possible-values-list
            {:form-props              form-props
             :keys-cfg                {:possible-values pf-events/sf-possible-values-key}
             :on-delete-item          (fn [item _] (re-frame/dispatch [::pf-events/sf-check-item-value-usage item]))
             :on-add-item             (fn [_] nil)
             :on-edit-item            (fn [item _] (re-frame/dispatch [::pf-events/sf-open-rename-value-modal item]))
             :always-editable-values? true
             :action-in-progress?     action-in-progress?
             :is-global-field?        false}])
         (when has-ll-editing?
           [:<>
            [:div.g2-field-container
             [:label.m-label (get-translation "global-fields.form-fields.parent-list" "Parent list:")]
             [:div
              [:span (get-translation "global-fields.form-fields.issue-status-parent" "Issue Status - ")]
              [:a {:href (str "/projects/" project-id "/workflow_editor?entity_type=Issue")}
               (get-translation "global-fields.form-fields.project-workflow" "Project Workflow")]]]
            [cf-form-common/linked-values-list
             {:form-props              form-props
              :keys-cfg                {:possible-values pf-events/sf-possible-values-key}
              :parent-list-items       parent-list-values
              :on-delete-item          (fn [parent-item]
                                         (fn [child-item _]
                                           (re-frame/dispatch [::pf-events/sf-check-item-value-usage child-item parent-item])))
              :on-add-item             (fn [_] nil)
              :on-edit-item            (fn [parent-item]
                                         (fn [child-item _]
                                           (re-frame/dispatch [::pf-events/sf-open-rename-value-modal child-item parent-item])))
              :always-editable-values? true
              :action-in-progress?     action-in-progress?
              :is-global-field?        false}]])
         [cf-form-common/entity-linker-section
          {:form-props            form-props
           :keys-cfg              {:entity-table pf-events/sf-entity-link-table-id}
           :show-select-projects? false
           :entity-linker-opts    {:available?             true
                                   :field-format           field-format
                                   :show-mandatory?        (:supports_mandatory system-field)
                                   :show-default-value?    (:supports_default_value system-field)
                                   :allowed-entities       allowed-entities
                                   :possible-values        (when (seq possible-values) possible-values)
                                   :users                  users
                                   :testset-as-checkboxes? true}}]]]
       [sf-form-footer]])))

(defn system-field-edit-page []
  (let [init-done?   @(re-frame/subscribe [:project-fields-settings/init-complete?])
        system-field @(re-frame/subscribe [:project-fields-settings/seeded-system-field])]
    (when (and init-done? system-field)
      [system-field-edit-inner system-field])))
